import React, { useEffect, useState } from "react";
import "./AboutUs.css";
import AOS from "aos";
import "aos/dist/aos.css";
// import Navbar from "../../Components/navbar/Navbar";
// import NewNavbar from "../../Components/newNavbar/NewNavbar";
import Navbar from "../../Components/New_Components/Navbar";
import CompanyImage from "../../assets/evacassets/image/CompanyImage.png";

function AboutUs() {
  const [content, setContent] = useState(0);
  // const {theme} = prop
  const token = localStorage.getItem("token");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const isMobile = window.innerWidth <= 600;
  const isTablet = window.innerWidth > 600 && window.innerWidth <= 1024;

  const theme =
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";

  function MyAnimation() {
    AOS.init({ duration: 2000 });
  }

  useEffect(() => {
    function handleScroll() {
      AOS.init({ duration: 2000 });
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="bg-white">
      <Navbar />

      <div className=" custom-container  my-5">
        <div className="row d-flex flex-column-reverse flex-lg-row align-items-center">
          <div className="col-lg-9 text-start mt-4 mt-lg-0">
            <h2 className="fw-bold mb-3">About Us</h2>
            <br />
            <h4 className="fw-semibold mb-3">
              Pyramid Electronics can trace its roots to the early days of power
              electronics in India
            </h4>
            <p style={{ color: "#595959", lineHeight: "1.7" }}>
              Pyramid Electronics was founded in 1993 to manufacture stand-alone
              UPS systems and domestic inverters in Panchkula, Haryana, India.
              In 2004, Pyramid started the second unit in Himachal Pradesh to
              enhance the production capacity. Pyramid designs are backed by
              over 20 years of field experience and thousands of installations
              across India. A solid blend of experienced personnel, the latest
              design techniques, and engineering skills helps us ensure superior
              power conversion products. The test and inspection departments are
              equipped with all modern test facilities. Presently, the company
              mainly focuses on the following power conditioning products: Grid
              Tied Solar Inverters (3KW-50KW), EV Chargers (7.4KW-50KW) and
              Online UPS (5KW-120KW).
            </p>

            {/* Stats Row */}
            <div className="d-flex flex-wrap gap-5 mt-5">
              <div>
                <h3 className="fw-bold">30+</h3>
                <p className="mb-0" style={{ color: "#595959" }}>
                  Years Experience
                </p>
              </div>
              <div>
                <h3 className="fw-bold">100%</h3>
                <p className="mb-0" style={{ color: "#595959" }}>
                  Quality Focus
                </p>
              </div>
              <div>
                <h3 className="fw-bold">150+</h3>
                <p className="mb-0" style={{ color: "#595959" }}>
                  Employees
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-3 text-center mb-4 mb-lg-0">
            <img
              src={CompanyImage}
              alt="Pyramid Electronics Building"
              className="img-fluid rounded shadow"
              style={{
                maxHeight: "350px",
                objectFit: "cover",
                borderRadius: "16px",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default AboutUs;
